import { useEffect, useRef } from 'react';

import { useSearchParams } from 'react-router';

import { useWidgetAnimation } from '@/features/Dashboard/context/WidgetAnimation/hooks';
import { ShareBlockNames } from '@/pages/Markets/MarketsComponents/Share/ShareBlock';
import { sanitizeName } from '@/utils/sanitizeName';

export const useBlockTabNavigation = <T extends { name: string }>(
  tabs: T[],
  blockName: ShareBlockNames,
  blockIndex: number,
  setActiveTab: (id: number) => void
) => {
  const blockRef = useRef<HTMLDivElement>(null);
  const [urlSearchParams, setSearchParams] = useSearchParams();
  const { setElementsToAnimateId } = useWidgetAnimation();

  const params = urlSearchParams.get('element');
  useEffect(() => {
    if (params) {
      const element = params.split(',')?.[0];
      if (element) {
        const [blockId, tabId] = element.split(':');
        if (blockId === `${sanitizeName(blockName)}-${blockIndex}`) {
          const tabIndex = tabs.findIndex(tab => sanitizeName(tab.name) === tabId);
          if (tabIndex !== -1) {
            setActiveTab(tabIndex);
          }
          const containerId = blockRef.current?.parentElement?.id;
          if (containerId) {
            setElementsToAnimateId([containerId]);
          }
          setSearchParams({});
        }
      }
    }
  }, [blockIndex, blockName, params, setActiveTab, setElementsToAnimateId, setSearchParams, tabs]);
  return { blockRef };
};
